import { createBlueprint as e } from "@made-people/blueprint";
const t = e({
  slots: {
    base: "rounded-md overflow-hidden",
    wrapper: "flex flex-col justify-center items-center p-8",
    image: "h-12 w-full object-cover mb-4",
    headingWrapper: "text-heading-md mb-2",
    body: "lg:w-3/4 text-body-sm text-center mb-4",
    linksWrapper: "flex flex-row gap-4",
    detailsWrapper: "flex flex-col lg:flex-row justify-between w-full gap-1"
  },
  variants: {
    theme: {
      primary: {
        base: ""
      },
      secondary: {
        base: ""
      },
      white: {
        base: ""
      },
      black: {
        base: ""
      },
      grey: {
        wrapper: "bg-background-surface-1",
        detailsWrapper: "bg-white/40"
      },
      green: {
        base: ""
      }
    }
  },
  defaultVariants: {
    theme: "grey"
  }
}), l = e({
  slots: {
    base: "flex flex-col flex-1 gap-1 p-8 text-center items-center",
    icon: "w-6 h-6 mb-1",
    headingWrapper: "",
    body: "text-body-xs"
  },
  variants: {}
}), a = e({
  slots: {
    base: "flex flex-col bg-background-surface-1 rounded-md overflow-hidden",
    wrapper: "flex flex-col lg:flex-row lg:gap-12 items-center",
    imageWrapper: "basis-1/2 w-full",
    image: "h-[200px] lg:h-[400px] w-full object-cover",
    contentWrapper: "m-6 lg:m-0 lg:mr-12 basis-1/2 flex flex-col text-left",
    eyebrow: "text-heading-xs mb-2",
    headingWrapper: "mb-2",
    body: "text-body-sm",
    linksWrapper: "flex flex-row gap-4 items-center mt-4",
    detailsWrapper: "flex flex-col lg:flex-row justify-between w-full gap-1 bg-white/40"
  },
  variants: {}
});
export {
  a as actionCardAlbertaStyling,
  l as actionCardDetailStyling,
  t as actionCardTorontoStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
